import React from "react";
import { ReactSession } from 'react-client-session';
import {encode as base64_encode} from 'base-64';

import { Helpers } from "../../config/Helpers";

class Balance extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessKodeNasabah: (ReactSession.get("sess_kodenasabah")) ? ReactSession.get("sess_kodenasabah") : '',
            loading: true,
            summaryData: '',
        };
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            this.loadBalance();
        }
    }

    loadBalance = () => {
        this.setState({ loading: true });

        Helpers.getSummary(this.state.sessUserCode, this.state.sessKodeNasabah).then(res => {
            if(res && res.length > 0){
                this.setState({
                    summaryData: res[0],
                    loading: false
                });
            }else{
                this.setState({ loading: false });
            }
        });
    };

    goBBXPoin = () => {
        window.location.href = './bbx-poin-login?redirectUrl=' + base64_encode(window.location.href);
    };

    disconnectBBXPoin = () => {
        if(window.confirm('Apakah anda yakin akan keluar dari BBX Akun?')){
            ReactSession.set("sess_kodenasabah", '');

            this.setState({ sessKodeNasabah: '' }, () => {
                this.loadBalance();
            });
        }
    };

    openVoucher = () => {
        window.location.href = './account-mutasi-voucher';
    };

    openPoints = () => {
        window.location.href = './account-mutasi-komisi';
    };

    openLimit = () => {
        window.location.href = './account-mutasi-limit';
    };

    render() {
        const { summaryData } = this.state;

        return (
            <>
                <main className="main pages detail-page-wrap">
                    <div className="detail-topbar">
                        <a href="./account" className="detail-topbar-back"><i className="fi-rs-arrow-small-left"></i></a>
                        <h1 className="detail-topbar-title">Saldo &amp; Poin</h1>
                    </div>

                    <div className="detail-wrap">
                        <div className="detail-card">
                            <div className="detail-card-head">
                                <span className="detail-card-accent"></span>
                                <span className="detail-card-title">Semua saldo, poin, dan limit kredit kamu</span>
                            </div>

                            {
                                this.state.loading ? (
                                    <div className="detail-info-box">
                                        <div className="detail-info-row">
                                            <span className="detail-info-label">Memuat data...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="balance-row" onClick={() => {this.openVoucher()}}>
                                            <img src="./assets/imgs/icon/balance/ic_voucher.png" alt="Voucher" className="balance-icon"/>
                                            <div className="balance-text">
                                                <div className="balance-name">Voucher Waroq</div>
                                                <div className="balance-value">{(summaryData && summaryData.saldo_waroq) || '0'}</div>
                                            </div>
                                            <i className="fi-rs-angle-small-right balance-chevron"></i>
                                        </div>

                                        <div className="balance-row" onClick={() => {this.openPoints()}}>
                                            <img src="./assets/imgs/icon/balance/ic_coin.png" alt="Poin" className="balance-icon"/>
                                            <div className="balance-text">
                                                <div className="balance-name">Waroq Poin</div>
                                                <div className="balance-value">{(summaryData && summaryData.commission_now) || '0'}</div>
                                            </div>
                                            <i className="fi-rs-angle-small-right balance-chevron"></i>
                                        </div>

                                        <div className="balance-row" onClick={() => {this.openLimit()}}>
                                            <img src="./assets/imgs/icon/balance/ic_limit.png" alt="Limit Kredit" className="balance-icon"/>
                                            <div className="balance-text">
                                                <div className="balance-name">Limit Kredit</div>
                                                <div className="balance-value">{(summaryData && summaryData.credit_limit) || '0'}</div>
                                            </div>
                                            <i className="fi-rs-angle-small-right balance-chevron"></i>
                                        </div>

                                        <div className="balance-row">
                                            <img src="./assets/imgs/icon/bbx_poin.png" alt="BBX Poin" className="balance-icon"/>
                                            <div className="balance-text">
                                                <div className="balance-name">BBX Poin</div>
                                                {
                                                    this.state.sessKodeNasabah && (
                                                        <div className="balance-value">{parseInt((summaryData && summaryData.bbx_poin) || 0).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</div>
                                                    )
                                                }
                                            </div>
                                            {
                                                !this.state.sessKodeNasabah ? (
                                                    <button type="button" className="balance-connect-btn" onClick={() => {this.goBBXPoin()}}>Hubungkan</button>
                                                ) : (
                                                    <button type="button" className="balance-connect-btn" onClick={() => {this.disconnectBBXPoin()}}>Batalkan</button>
                                                )
                                            }
                                        </div>

                                        <div className="balance-row">
                                            <img src="./assets/imgs/icon/bbx_tabungan.png" alt="BBX Saving" className="balance-icon"/>
                                            <div className="balance-text">
                                                <div className="balance-name">BBX Saving</div>
                                                {
                                                    this.state.sessKodeNasabah && (
                                                        <div className="balance-value">{parseInt((summaryData && summaryData.bbx_tabungan) || 0).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</div>
                                                    )
                                                }
                                            </div>
                                            {
                                                !this.state.sessKodeNasabah ? (
                                                    <button type="button" className="balance-connect-btn" onClick={() => {this.goBBXPoin()}}>Hubungkan</button>
                                                ) : (
                                                    <button type="button" className="balance-connect-btn" onClick={() => {this.disconnectBBXPoin()}}>Batalkan</button>
                                                )
                                            }
                                        </div>
                                    </>
                                )
                            }
                        </div>
                    </div>
                </main>
            </>
        );
    }
}

export default Balance;
